// extracted by mini-css-extract-plugin
export default {"modalWrapper":"HpfF3VPt7ln7kwPj50IR"};